import { ROLES } from 'variables';
import { lazy } from 'react';

// project import
import Loadable from 'components/@ui/loader/Loadable';

// PROGRAMS & PLANS
const Programs = Loadable(lazy(() => import('pages/commons/prgoram-management/Programs')));
const Program = Loadable(lazy(() => import('pages/commons/prgoram-management/program-details/ProgramDetailsPage')));
const ProgramCreationPage = Loadable(lazy(() => import('pages/commons/prgoram-management/program-creation/ProgramCreationPage')));

const Plan = Loadable(lazy(() => import('pages/corporate/distribution-plan-management/distribution-plan-details/DistributionPlanDetails')));

const CreatePlan = Loadable(
  lazy(() => import('pages/corporate/distribution-plan-management/distribution-plan-creation/LicesneGeneration'))
);

const PlanAllocation = Loadable(lazy(() => import('pages/corporate/license-management/license-allocation/LicenseAllocation')));

const SponsorshipsCreationPage = Loadable(
  lazy(() => import('pages/corporate/sponsorships-management/sponsorships-creation/SponsorshipsCreationPage'))
);

// MARKETPLACE
const Ma_Programs = Loadable(lazy(() => import('pages/admin/marketplace-management/MarketPlace')));

// const ProgramCreationPage = Loadable(lazy(() => import('pages/admin/marketplace-management/program-creation/ProgramCreationPage')));

const Ma_Program = Loadable(lazy(() => import('pages/admin/marketplace-management/program-details/ProgramDetailsPage')));

// EMPLOYEES
const Employees = Loadable(lazy(() => import('pages/corporate/employee-management/employees/Employees')));
const Employee = Loadable(lazy(() => import('pages/corporate/employee-management/employees/employee-details/EmployeeDetails')));
const EmployeeGroups = Loadable(lazy(() => import('pages/corporate/employee-management/employee-groups/EmployeeGroups')));
const EmployeeGroup = Loadable(
  lazy(() => import('pages/corporate/employee-management/employee-groups/employee-groups-details/EmployeeGroupsDetails'))
);
const AddEmployees = Loadable(lazy(() => import('pages/corporate/employee-management/employees/employee-creation/CreateEmployeePage')));
const AddEmployeeGroup = Loadable(
  lazy(() => import('pages/corporate/employee-management/employee-groups/employee-group-creation/EmployeeGroupCreatonPage'))
);

// FINANCIALS
const Financials = Loadable(lazy(() => import('pages/corporate/financial-management/Financials')));
const Wallets = Loadable(lazy(() => import('pages/corporate/financial-management/wallet-management/WalletPage')));
const AddWalletFunds = Loadable(lazy(() => import('pages/corporate/financial-management/wallet-management/wallet-funding/FundWalletPage')));
const Transactions = Loadable(lazy(() => import('pages/corporate/financial-management/transaction-management/Transactions')));
const Transaction = Loadable(
  lazy(() => import('pages/corporate/financial-management/transaction-management/transaction-details/TransactionDetailsPage'))
);
const Payments = Loadable(lazy(() => import('pages/corporate/financial-management/payments-management/payments-listing/PaymentsTable')));

// FINANCIALS
const Licenses = Loadable(lazy(() => import('pages/corporate/license-management/license-allocation/LicenseAllocation')));
const LicenseGenerations = Loadable(lazy(() => import('pages/corporate/license-management/license-generation/LicesneGeneration')));

// CLAIMS
const Claims = Loadable(lazy(() => import('pages/corporate/claims-management/listing/ClaimsTable')));

// LICENSES
const LicenseList = Loadable(lazy(() => import('pages/commons/ma-license-management/licenses/listing/LicensesTable')));
const LicenseTypes = Loadable(lazy(() => import('pages/commons/ma-license-management/license-types/listing/LicenseTypesTable')));

// SUPPORT
// const Support = Loadable(lazy(() => import('pages/common/support/SupportForm')));
const Support = Loadable(lazy(() => import('pages/common/support/Support')));

// TEST
const Test = Loadable(lazy(() => import('pages/corporate/employee-management/employees/employee-details/EmployeeDetailPage')));
// const Support = Loadable(lazy(() => import('components/widgets/components/TimelineWidget')));

// SIMULATOR
const Simulator = Loadable(lazy(() => import('pages/simulator/Simulator')));

// assets
import CampaignIcon from '@mui/icons-material/Campaign';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import StorefrontIcon from '@mui/icons-material/Storefront';
import CalculateIcon from '@mui/icons-material/Calculate';
import ReceiptIcon from '@mui/icons-material/Receipt';
import GroupsIcon from '@mui/icons-material/Groups';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import PaymentIcon from '@mui/icons-material/Payment';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import { TabletSmartphone } from 'lucide-react';

// icons
const icons = {
  CampaignIcon,
  HandshakeOutlinedIcon,
  StorefrontIcon,
  CalculateIcon,
  ReceiptIcon,
  GroupsIcon,
  VolunteerActivismIcon,
  PaymentIcon,
  AccountBalanceWalletIcon,
  WorkspacePremiumIcon,
  TabletSmartphone
  // Add more icons as needed
};

//======================= VASEELAH ADMIN ROUTES ===================================//
export const corporateRoutes = [
  // BENEFICIARIES
  {
    path: 'employees',
    element: <Employees />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },
  {
    path: 'employees/add',
    element: <AddEmployees />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },
  {
    path: 'employees/:employeeId',
    element: <Test />,
    // element: <></>,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },

  {
    path: 'employees/employee-groups',
    element: <EmployeeGroups />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },

  {
    path: 'employees/employee-groups/new',
    element: <AddEmployeeGroup />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },

  {
    path: 'employees/employee-groups/:groupKey',
    element: <EmployeeGroup />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },

  {
    path: 'employees/activation-codes',
    element: <h1>Programs</h1>,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },

  // MARKETPLACE
  // {
  //   path: 'marketplace/incentive-programs',
  //   element: <Ma_Programs />,
  //   allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
  //   featureCode: 'marketplace-management'
  // },
  // {
  //   path: 'marketplace/incentive-programs/new',
  //   element: <ProgramCreationPage />,
  //   allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
  //   featureCode: 'marketplace-management'
  // },
  // {
  //   path: 'marketplace/incentive-programs/:programId/details',
  //   element: <Ma_Program />,
  //   allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
  //   featureCode: 'marketplace-management'
  // },

  // PROGRAMS
  {
    path: 'programs',
    element: <Programs />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },
  // {
  //   path: 'programs/new',
  //   element: <ProgramCreationPage />,
  //   allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
  //   featureCode: 'vaseelah'
  // },
  {
    path: 'programs/:programId',
    element: <ProgramCreationPage />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },
  {
    path: 'programs/:programId/details',
    element: <Program />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },
  {
    path: 'programs/:programId/details/plan/new',
    element: <CreatePlan />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },
  {
    path: 'programs/:programId/details/plan/:planId',
    element: <Plan />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },

  {
    path: 'programs/:programId/details/plan/:planId/sponsorships/new',
    element: <SponsorshipsCreationPage />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },

  {
    path: 'programs/:programId/details/plan/:planId/employee/:employeeId',
    element: <Employee />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },
  {
    path: 'programs/:programId/details/plan/:planId/allocate',
    element: <PlanAllocation />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },

  // Licenses
  {
    path: 'licenses/list',
    element: <LicenseList />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  },

  // {
  //   path: 'licenses/types',
  //   element: <LicenseTypes />,
  //   allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
  //   featureCode: 'priseen'
  // },

  // FINANTIAL PERFORMANCE
  {
    path: 'financials',
    element: <Financials />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },
  {
    path: 'financials/transactions',
    element: <Transactions />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },
  {
    path: 'financials/transactions/:transactionId',
    element: <Transaction />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },

  {
    path: 'financials/payments',
    element: <Payments />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },
  {
    path: 'financials/payments/:transId',
    element: <Payments />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },

  {
    path: 'financials/program-accounts',
    element: <Wallets />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },
  {
    path: 'financials/program-accounts/:walletAddress',
    element: <AddWalletFunds />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },
  {
    path: 'financials/program-accounts/:walletAddress/transactions',
    element: <Transactions />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },

  // FINANTIAL PERFORMANCE
  // {
  //   path: 'licenses',
  //   element: <Licenses />,
  //   allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
  //   featureCode: 'vaseelah'
  // },
  // {
  //   path: 'licenses/generate',
  //   element: <LicenseGenerations />,
  //   allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
  //   featureCode: 'vaseelah'
  // },

  // CLAIMS
  {
    path: 'claims',
    element: <Claims />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },

  // SUPPORT
  {
    path: 'support',
    element: <Support />,
    // element: <Test />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'vaseelah'
  },

  {
    path: 'simulator',
    element: <Simulator />,
    // element: <Test />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'priseen'
  }
];

//=============================== VASEELAH ADMIN MENU ITEMS===============================//

export const corporateMenuItems = [
  // {
  //   id: 'license-management',
  //   title: 'Licenses',
  //   type: 'item',
  //   url: '/licenses',
  //   icon: icons.CampaignIcon,
  //   breadcrumbs: true,
  //   feature_code: 'lisence-management'
  // },
  {
    id: 'programs',
    title: 'Programs',
    type: 'item',
    url: '/programs',
    icon: icons.CampaignIcon,
    breadcrumbs: true,
    feature_code: 'programs'
  },

  {
    id: 'licenses',
    title: 'License Management',
    type: 'collapse',
    url: '/licenses',
    icon: icons.WorkspacePremiumIcon,
    breadcrumbs: true,
    feature_code: 'license-management',
    children: [
      {
        id: 'licenses',
        title: 'List',
        type: 'item',
        url: '/licenses/list',
        breadcrumbs: true,
        feature_code: 'license-management'
      }
      // {
      //   id: 'license-types',
      //   title: 'Types',
      //   type: 'item',
      //   url: '/licenses/types',
      //   breadcrumbs: true,
      //   feature_code: 'license-management'
      // }
      // {
      //   id: 'programs-by-consumer-group',
      //   title: 'Programs',
      //   type: 'item',
      //   url: '/employees/activation-codes',
      //   breadcrumbs: true,
      //   feature_code: 'employee-management'
      // }
    ]
  },

  {
    id: 'claim-management',
    title: 'Claims',
    type: 'item',
    url: '/claims',
    icon: icons.CampaignIcon,
    breadcrumbs: true,
    feature_code: 'claim-management'
  },

  {
    id: 'employees',
    title: 'Employee Management',
    type: 'collapse',
    url: '/employees',
    icon: icons.GroupsIcon,
    breadcrumbs: true,
    feature_code: 'employee-management',
    children: [
      {
        id: 'employees',
        title: 'List',
        type: 'item',
        url: '/employees',
        breadcrumbs: true,
        feature_code: 'employee-management'
      },
      {
        id: 'employee-groups',
        title: 'Groups',
        type: 'item',
        url: '/employees/employee-groups',
        breadcrumbs: true,
        feature_code: 'employee-management'
      }
      // {
      //   id: 'programs-by-consumer-group',
      //   title: 'Programs',
      //   type: 'item',
      //   url: '/employees/activation-codes',
      //   breadcrumbs: true,
      //   feature_code: 'employee-management'
      // }
    ]
  },

  // {
  //   id: 'marketplace',
  //   title: 'Marketplace',
  //   type: 'item',
  //   url: '/marketplace/incentive-programs',
  //   icon: icons.CampaignIcon,
  //   breadcrumbs: true,
  //   feature_code: 'marketplace'
  // },

  {
    id: 'financials',
    title: 'Financials',
    type: 'collapse',
    url: '/financials',
    icon: icons.CalculateIcon,
    breadcrumbs: true,
    feature_code: 'financial-management',
    children: [
      {
        id: 'wallets',
        title: 'Program Accounts',
        type: 'item',
        url: '/financials/program-accounts',
        breadcrumbs: true,
        feature_code: 'financial-management'
      },
      {
        id: 'transactions',
        title: 'Transactions',
        type: 'item',
        url: '/financials/transactions',
        breadcrumbs: true,
        feature_code: 'financial-management'
      },
      {
        id: 'payments',
        title: 'Payments',
        type: 'item',
        url: '/financials/payments',
        breadcrumbs: true,
        feature_code: 'financial-management'
      }
    ]
  },

  {
    id: 'support',
    title: 'Support',
    type: 'item',
    url: '/support',
    icon: icons.PaymentIcon,
    breadcrumbs: true,
    feature_code: 'support'
  },

  {
    id: 'simulator',
    title: 'Simulator',
    type: 'item',
    url: '/simulator',
    icon: icons.TabletSmartphone,
    breadcrumbs: true,
    feature_code: 'simulator'
  }
];
